export const networkStrengths = {
    ONLINE:"ONLINE",
    OFFLINE: "OFFLINE",
};
